import { call, put } from "redux-saga/effects";
import PlanGroupActions from "./plan-group-actions";
import * as api from "../../services/api";

export function* getPlanGroupsGraphedActive(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getPlanGroupsGraphedActive, businessId);

  // success?
  if (response.ok) {
    yield put(PlanGroupActions.planGroupGraphedActiveSuccess(response.data));
    // console.log(response.data);
  } else {
    yield put(PlanGroupActions.planGroupGraphedActiveFailure(response.data));
  }
}

export function* getPlanGroupsGraphedAll(action) {
  const { businessId } = action;
  const response = yield call(api.getPlanGroupsGraphedAll, businessId);

  if (response.ok) {
    yield put(PlanGroupActions.planGroupGraphedAllSuccess(response.data));
  } else {
    yield put(PlanGroupActions.planGroupGraphedAllFailure(response.data));
  }
}
export function* getPlanGroups(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getPlanGroups, businessId);

  // success?
  if (response.ok) {
    yield put(PlanGroupActions.planGroupsSuccess(response.data));
    // console.log(response.data);
  } else {
    yield put(PlanGroupActions.planGroupsFailure(response.data));
  }
}

export function* getPlanGroupsGraphedArchived(action) {
  const { businessId } = action;
  // make the call to the api
  const response = yield call(api.getPlanGroupsGraphedArchived, businessId);

  // success?
  if (response.ok) {
    yield put(PlanGroupActions.planGroupGraphedArchivedSuccess(response.data));
  } else {
    yield put(PlanGroupActions.planGroupGraphedArchivedFailure(response.data));
  }
}

export function* getPlan(action) {
  const { businessId, options } = action;

  if (!businessId) return;

  const response = yield call(api.getPlans, businessId, options);

  if (response.ok) {
    yield put(PlanGroupActions.planSuccess(response.data));
  } else {
    yield put(PlanGroupActions.planFailure(response.data));
  }
}

export function* createPlanGroup(action) {
  const { planGroup } = action;
  const response = yield call(api.createPlanGroup, planGroup);

  if (response.ok) {
    yield put(PlanGroupActions.planGroupCreateSuccess(response.data));
  } else {
    yield put(PlanGroupActions.planGroupCreateFailure(response.data));
  }
}

export function* updatePlanGroup(action) {
  const { planGroupId, planGroup } = action;
  const response = yield call(api.updatePlanGroup, planGroupId, planGroup);

  if (response.ok) {
    yield put(PlanGroupActions.planGroupUpdateSuccess(response.data));
  } else {
    yield put(PlanGroupActions.planGroupUpdateFailure(response.data));
  }
}

export function* addWatchers(action) {
  const { watcher } = action;
  const response = yield call(api.addProductWatcher, watcher);

  if (response.ok) {
    yield put(PlanGroupActions.addWatcherSuccess(response.data));
  } else {
    yield put(PlanGroupActions.addWatcherFailure(response.data));
  }
}

export function* removeWatchers(action) {
  const { watcherId } = action;
  const response = yield call(api.removeProductWatcher, watcherId);

  if (response.ok) {
    yield put(PlanGroupActions.removeWatcherSuccess(watcherId));
  } else {
    yield put(PlanGroupActions.removeWatcherFailure(response.data));
  }
}

export function* productWatchers(action) {
  const { planGroupId } = action;
  const response = yield call(api.productWatchers, planGroupId);

  if (response.ok) {
    yield put(PlanGroupActions.productWatcherSuccess(response.data));
  } else {
    yield put(PlanGroupActions.productWatcherFailure(response.data));
  }
}

export function* leaderBoard(action) {
  const { planGroupId } = action;
  const response = yield call(api.leaderBoard, planGroupId);

  if (response.ok) {
    yield put(PlanGroupActions.leaderBoardSuccess(response.data));
  } else {
    yield put(PlanGroupActions.leaderBoardFailure(response.data));
  }
}